module.exports = __webpack_public_path__ + "img/img1.f9088295.png";